import React, { Component } from 'react';
class IframeContainer extends Component {
    render() {
        return (<iframe src={this.props.iframeUrl} frameBorder="0" style={{
            height: 'calc(100vh - 175px)',
            width: '100%'
        }}/>);
    }
}
export default IframeContainer;
